import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasStepDetails = lazy(() =>
  import("@canvas/CanvasStepDetails").then((module) => ({
    default: module.CanvasStepDetails,
  }))
);

export const surveysHubCanvasStepDetailsNRO: NavigationRoutingObject = {
  Component: CanvasStepDetails,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("surveys-sidebar-pill-menu-option", "Surveys"),
  pageNameForTracking: () => "Surveys Hub - Canvas Step",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("surveys-sidebar-pill-menu-option-description", "View surveys across landing pages, campaigns, and Canvas"),
  icon: "nav-system-surveys",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("surveys_hub_detail_page") &&
      featureOn("surveys_hub") &&
      featureOn("iam_surveys") &&
      featureOn("journeys") &&
      hasPermission("appGroup", { permission: "viewCanvases" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  showInSearchResults: false,
  defaultRoute: "/engagement/surveys/:appGroupId",
};
